import axios from "@/plugins/axios.js"

const actions = {
  fetchOrders({ commit, state}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/orders?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          if(response.data.success){
            commit('SET_ORDERS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchOrder({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/orders/${orderId}/show`)
        .then((response) => {
          if(response.data.success){
            commit('SET_ORDER', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchDeliveries({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/order-deliveries?order_id=${orderId}`)
        .then((response) => {
          if(response.data.success){
              commit('SET_ORDER_DELIVERIES', response.data.data)
           }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchMessages({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/order-messages?order_id=${orderId}`)
        .then((response) => {
          if(response.data.success){
              commit('SET_ORDER_MESSAGES', response.data.data)
           }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  multipleAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(payload.action, payload.formData)
        .then((response) => {
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
}

const getters = {}


const mutations = {
  SET_ORDERS(state, data) {
    state.pageData = data
  },
  SET_ORDER(state, order){
  	state.order = order
  },
  DELETE_ORDER(state, orderId){
    const itemIndex = state.pageData.data.findIndex((item) => item.id == orderId)
    state.pageData.data.splice(itemIndex, 1)
  },

  /**************** THIS IS FOR DELIVERIES********************/
  SET_ORDER_DELIVERIES(state, deliveries){
    state.order.deliveries = [...deliveries]
  },
  ADD_DELIVERY(state, delivery){
    state.order.deliveries.unshift(delivery)
  },
  UPDATE_DELIVERY(state, delivery){
    const dataIndex = state.order.deliveries.findIndex((a) => a.id == delivery.id);
    Object.assign(state.order.deliveries[dataIndex], delivery);
  },
  DELETE_DELIVERY(state, deliveryId){
    const itemIndex = state.order.deliveries.findIndex((item) => item.id == deliveryId)
      state.order.deliveries.splice(itemIndex, 1)
  },
  SET_DELIVERY(state, delivery){
    state.delivery = {...delivery}
  },

}

const state = {
  pageData: {
    data: []
  },
  order: {},
  delivery: {}
}

export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

